import React from 'react';
import { ListItemCardProps } from 'FieldServices/react/features/workflow/ListItemCards/ListItemCardProps';
import Box from '@powerednow/components/Box/Box';

function DefaultListItemCard({ workflow, index } : ListItemCardProps) {
    return (
        <Box>
            <b>
                {workflow.workflow.title}
            </b>
            {' '}
            {workflow.workflow.description}
        </Box>
    );
}

export default DefaultListItemCard;
